import React from 'react';
import setClass from './set-class';
const newc = (props, defaultClass) => {
    const { style, className, children, component: Component, testId } = props;
    if (Component) {
        return React.createElement(Component, { ...props });
    }
    return (React.createElement("div", { style: style, className: setClass(className, defaultClass), "data-testid": testId }, children));
};
export default newc;
